import { ValidationErrors, ValidatorFn, AbstractControl, FormArray } from "@angular/forms";
import { FormsUtilities } from "./forms";

/**
 * Validator that requires a FormArray to have a minimum number of valid phone numbers.
 *
 * @param min - Minimum number of valid phones required
 * @param phoneRegex - Optional regex pattern for phone validation (defaults to FormsUtilities.phoneRegEx)
 * @returns ValidatorFn that returns null if valid, or error object with required and actual valid phone counts
 *
 * @example
 * // Basic usage with default phone regex
 * this.phonesArray = this.fb.array([], minValidPhonesValidator(2));
 *
 * @example
 * // Custom phone regex
 * const customRegex = /^\d{10}$/;
 * this.phonesArray = this.fb.array([], minValidPhonesValidator(1, customRegex));
 */
export function minValidPhonesValidator(min: number, phoneRegex: RegExp = FormsUtilities.phoneRegEx): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    if (formArray instanceof FormArray) {
      const validPhones = formArray.controls.filter((ctrl) => {
        const value = (ctrl.value || "").toString().trim();
        return value !== "" && phoneRegex.test(value);
      });

      return validPhones.length >= min
        ? null
        : { minValidPhones: { requiredValid: min, actualValid: validPhones.length } };
    }
    return null;
  };
}
